export function founderBadgeAccessibilityLabel() {
  return 'Frienzzi founder';
}

export function founderBadgeTooltipText() {
  return 'Founder of Frienzzi: Jason started Frienzzi and helps guide the product, community, and company.';
}
